import React, { FC } from 'react'
import FormattedHtmlContent from 'src/components/ui/FormattedHtmlContent'

export interface ITextItemProps {
  content: string
  noMargin?: boolean
}

export interface ITextItemData extends ITextItemProps {
  id: string
  type: 'TextItem'
}

const TextItem: FC<ITextItemProps> = ({ content, noMargin = false }) => (
  <FormattedHtmlContent
    noMargin={noMargin}
    className={`${noMargin ? 'mb-0' : 'mb-6'} text-megaDarkGray dark:text-white font-semibold leading-2`}
    dangerouslySetInnerHTML={{ __html: content }}
  />
)

export default TextItem
